const sysStudentInfo = () =>
    import(/* webpackChunkName: "student" */'../views/student/sysStudentInfo');
const sysEntryForm = () =>
    import(/* webpackChunkName: "student" */'../views/student/sysEntryForm');
const sysTicket = () =>
    import(/* webpackChunkName: "student" */'../views/student/sysTicket');
const sysScoreLook = () =>
    import(/* webpackChunkName: "student" */'../views/student/sysScoreLook');
const sysAdmissionStatus = () =>
    import(/* webpackChunkName: "student" */'../views/student/sysAdmissionStatus');
const sysStudentExamFileUpload = () =>
    import(/* webpackChunkName: "student" */'../views/student/sysStudentExamFileUpload');
const sysStudentSituationInfo = () =>
    import(/* webpackChunkName: "student" */'../views/student/sysStudentSituationInfo');

export default [
    {
        path: '/sysStudentInfo',
        name: 'sysStudentInfo',
        component: sysStudentInfo
    },
    {
        path: '/sysEntryForm',
        name: 'sysEntryForm',
        component: sysEntryForm
    },
    {
        path: '/sysTicket',
        name: 'sysTicket',
        component: sysTicket
    },
    {
        path: '/sysScoreLook',
        name: 'sysScoreLook',
        component: sysScoreLook
    },
    {
        path: '/sysAdmissionStatus',
        name: 'sysAdmissionStatus',
        component: sysAdmissionStatus
    },
    {
        path: '/sysStudentExamFileUpload',
        name: 'sysStudentExamFileUpload',
        component: sysStudentExamFileUpload
    },
    {
        path: '/sysStudentSituationInfo',
        name: 'sysStudentSituationInfo',
        component: sysStudentSituationInfo
    },
]